// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentTcsWrapperModelsMedicationModel {
    static getAttributeTypeMap() {
        return EnrollmentTcsWrapperModelsMedicationModel.attributeTypeMap;
    }
}
EnrollmentTcsWrapperModelsMedicationModel.discriminator = undefined;
EnrollmentTcsWrapperModelsMedicationModel.additionalProperties = false;
EnrollmentTcsWrapperModelsMedicationModel.attributeTypeMap = [
    {
        "name": "name",
        "baseName": "name",
        "type": "string"
    },
    {
        "name": "ndc",
        "baseName": "ndc",
        "type": "string"
    },
];
//# sourceMappingURL=enrollmentTcsWrapperModelsMedicationModel.js.map